import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { paymentsApi } from "./paymentsApi";

export const useInvoiceConfiguration = (paymentId: number | undefined, courseId?: number) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.INVOICE_CONFIGURATION(paymentId ?? 0, courseId),
    queryFn: () => paymentsApi.fetchInvoiceConfiguration(paymentId!, courseId),
    placeholderData: keepPreviousData,
    enabled: !!paymentId,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.INVOICE_CONFIGURATION(paymentId ?? 0, courseId),
    });
  };

  return { invalidate, isLoading, isFetching, configuration: data?.data ?? null };
};
